import { useCallback } from "react";
import {
  RedirectLoginOptions,
  useAuth0,
} from "@auth0/auth0-react";
import {
  auth0Domain,
  auth0LoginOptions,
  auth0LogoutOptions,
  isNativeApp,
} from "./runtime";

export default function useRank5Auth() {
  const auth = useAuth0();
  const domain = auth0Domain();

  const loginWithRedirect = useCallback(
    (options?: RedirectLoginOptions) =>
      auth.loginWithRedirect(
        auth0LoginOptions(domain, options?.appState)
      ),
    [auth, domain]
  );

  const loginWithPopup = useCallback(
    async () => {
      if (isNativeApp) {
        await auth.loginWithRedirect(auth0LoginOptions(domain));
        return;
      }
      await auth.loginWithPopup();
    },
    [auth, domain]
  );

  const logout = useCallback(
    () => auth.logout(auth0LogoutOptions(domain)),
    [auth, domain]
  );

  return {
    ...auth,
    loginWithRedirect,
    loginWithPopup,
    logout,
  };
}
